var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopBotton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_319",
    "data-name": "\\uADF8\\uB8F9 319",
    transform: "translate(-1750 -887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_39",
    "data-name": "\\uC0AC\\uAC01\\uD615 39",
    transform: "translate(1750 887)",
    fill: "#fff",
    stroke: "#43434b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uB2E4\\uAC01\\uD615_2",
    "data-name": "\\uB2E4\\uAC01\\uD615 2",
    d: "M15,0,30,16H0Z",
    transform: "translate(1770 913)",
    fill: "#43434b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBotton);
export default __webpack_public_path__ + "static/media/top_botton.8ca20c13811b9bb711d2ff07b5e600be.svg";
export { ForwardRef as ReactComponent };